import { Link, useLocation, useNavigate } from 'react-router-dom';
import { company } from '@/mocks/company';
import { services } from '@/mocks/services';

export default function Footer() {
  const navigate = useNavigate();
  const location = useLocation();

  const goTop = () => {
    if (location.pathname !== '/') {
      navigate('/');
    } else {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  };

  return (
    <footer className="border-t border-background-300/40 bg-background-100">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="py-16 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <Link to="/" className="flex items-center gap-3 cursor-pointer">
              <img
                src="/assets/logo.webp"
                alt="Matthias Klob GmbH Logo"
                className="w-12 h-12 rounded-sm object-contain"
              />
              <div className="flex flex-col leading-none">
                <span className="font-display font-extrabold uppercase tracking-tight text-foreground-50 text-2xl">
                  {company.shortName}
                </span>
                <span className="font-display font-semibold uppercase tracking-[0.28em] text-foreground-400 text-xs mt-1">
                  {company.legalForm}
                </span>
              </div>
            </Link>
            <p className="mt-5 max-w-xs text-sm leading-relaxed text-foreground-400">{company.tagline}</p>
            <div className="mt-5 flex items-center gap-2">
              <span className="flex text-primary-400 gap-0.5">
                {[...Array(5)].map((_, i) => (
                  <i key={i} className={`ri-star-${i < 4 ? 'fill' : 'half-fill'} text-sm`}></i>
                ))}
              </span>
              <span className="text-sm text-foreground-400">{company.rating} bei Google</span>
            </div>
          </div>

          <div>
            <h3 className="text-[12px] uppercase tracking-[0.2em] text-foreground-400">Navigation</h3>
            <ul className="mt-5 flex flex-col gap-3 text-[15px] text-foreground-100/85">
              <li><Link to="/" className="transition-colors hover:text-primary-400 cursor-pointer">Start</Link></li>
              <li><Link to="/leistungen" className="transition-colors hover:text-primary-400 cursor-pointer">Leistungen</Link></li>
              <li><Link to="/referenzen" className="transition-colors hover:text-primary-400 cursor-pointer">Referenzen</Link></li>
              <li><Link to="/ueber-uns" className="transition-colors hover:text-primary-400 cursor-pointer">Über uns</Link></li>
              <li><Link to="/karriere" className="transition-colors hover:text-primary-400 cursor-pointer">Karriere</Link></li>
              <li><Link to="/kontakt" className="transition-colors hover:text-primary-400 cursor-pointer">Kontakt</Link></li>
            </ul>
          </div>

          <div>
            <h3 className="text-[12px] uppercase tracking-[0.2em] text-foreground-400">Leistungen</h3>
            <ul className="mt-5 flex flex-col gap-3 text-[15px] text-foreground-100/85">
              {services.slice(0, 5).map((s) => (
                <li key={s.slug}>
                  <Link to="/leistungen" className="transition-colors hover:text-primary-400 cursor-pointer">
                    {s.title}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="text-[12px] uppercase tracking-[0.2em] text-foreground-400">Kontakt</h3>
            <ul className="mt-5 flex flex-col gap-3 text-[15px] text-foreground-100/85">
              <li className="flex items-center gap-2">
                <i className="ri-phone-line text-primary-400"></i>
                <a href={company.phoneHref} className="transition-colors hover:text-primary-400 cursor-pointer">{company.phone}</a>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-mail-line text-primary-400"></i>
                <a href={`mailto:${company.email}`} className="break-all transition-colors hover:text-primary-400 cursor-pointer">{company.email}</a>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-map-pin-line text-primary-400 mt-1"></i>
                <span>{company.street},<br />{company.city}</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="flex flex-wrap items-center justify-between gap-4 border-t border-background-300/40 py-7">
          <p className="text-sm text-foreground-400">© 2026 {company.name}. Alle Rechte vorbehalten.</p>
          <nav className="flex flex-wrap items-center gap-5 text-sm text-foreground-100/75">
            <Link to="/impressum" className="transition-colors hover:text-primary-400 cursor-pointer">Impressum</Link>
            <Link to="/datenschutz" className="transition-colors hover:text-primary-400 cursor-pointer">Datenschutz</Link>
          </nav>
          <button
            type="button"
            onClick={goTop}
            className="inline-flex items-center gap-1.5 text-sm font-semibold text-primary-400 transition-transform duration-200 hover:-translate-y-0.5 cursor-pointer"
          >
            Nach oben <i className="ri-arrow-up-line"></i>
          </button>
        </div>
      </div>
    </footer>
  );
}